export enum MiniDeletableTileType {
  TagBadge,
  TimetableBadge,
  TimetableExceptionBadge
}
